/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_optimizer_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Season consistency score (variance in points across races)`)
};

const es_about_optimizer_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación de consistencia de temporada (varianza en puntos entre carreras)`)
};

const de_about_optimizer_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saison-Konsistenzwert (Varianz der Punkte über die Rennen)`)
};

const nl_about_optimizer_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seizoensconsistentiescore (spreiding in punten over races)`)
};

const fr_about_optimizer_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score de régularité sur la saison (variance des points sur les courses)`)
};

const it_about_optimizer_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio di consistenza stagionale (varianza nei punti tra le gare)`)
};

const pt_br2_about_optimizer_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação de consistência na temporada (variância nos pontos entre corridas)`)
};

const pt_about_optimizer_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação de consistência na época (variância nos pontos entre corridas)`)
};

const ja_about_optimizer_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズン安定性スコア（レース間のポイント分散）`)
};

const zh_about_optimizer_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛季一致性评分（各场比赛积分方差）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_optimizer_li2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_optimizer_li2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_optimizer_li2", locale)
	if (locale === "en") return en_about_optimizer_li2(inputs)
	if (locale === "es") return es_about_optimizer_li2(inputs)
	if (locale === "de") return de_about_optimizer_li2(inputs)
	if (locale === "nl") return nl_about_optimizer_li2(inputs)
	if (locale === "fr") return fr_about_optimizer_li2(inputs)
	if (locale === "it") return it_about_optimizer_li2(inputs)
	if (locale === "pt-BR") return pt_br2_about_optimizer_li2(inputs)
	if (locale === "pt") return pt_about_optimizer_li2(inputs)
	if (locale === "ja") return ja_about_optimizer_li2(inputs)
	return zh_about_optimizer_li2(inputs)
};